'use strict';
define([
    'angular',
    'modules/seochecker/results/speed/speed.controller'
],function(angular,SEOCheckerSpeedCtrl){
    var app=angular.module('app.seochecker.results.speed', []);
    app.controller('SEOCheckerSpeedCtrl',SEOCheckerSpeedCtrl);
    return app;
});